import React, {useState, useEffect} from 'react'
import ReactPaginate from "react-paginate";

function PafFpgConvertModal(props) {
    const { closeModal, errorData } = props
    const [currentPage, setCurrentPage] = useState(0)
    const [offSet, setOffSet] = useState(0)
    const [perPage, setPerPage] = useState(15)
    const [items, setItems] = useState(errorData?.results?.filter(_ => _.success === false) || [])
    const [user, setUser] = useState(errorData?.results?.filter(_ => _.success === false) || [])
    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + perPage;
        setCurrentPage(selectedPage)
        setOffSet(offset)
    };

    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = offSet + perPage;
        setUser(items.slice(offSet, endOffset));
      }, [offSet, perPage]);

    return (
        <div className="user_popup active csv_upload_data">
            <span className="popup_overlay" onClick={closeModal}></span>
            <div className="sundance_popup_createuser box_shadow upload_csv_sundance_popup_createuser">
                <span className="closePopup pointer" onClick={closeModal}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.899 0L5.656 4.242L1.414 0L0 1.414L4.242 5.656L0 9.898L1.414 11.312L5.656 7.07L9.899 11.312L11.313 9.898L7.071 5.656L11.313 1.414L9.899 0Z" fill="black" /> </svg>
                </span>
                <div className="bg_white">
                    <div className="p_10">
                        <div className="selection_pass text_center">
                            <label className="pass_label mb_10">You have successfully converted total {errorData?.converted} FPG Push</label>
                        </div>
                        <div className="selection_pass text_center">
                            <span className="pass_label color_red">{errorData?.failed} record(s) were skipped</span>
                        </div>
                    </div>
                    {user && user.length > 0 ?
                        <div className="table_content bg_td_table">
                            <div className="table_wrap">
                                <table>
                                    <tr>
                                        <th className='text_left'>Reason</th>
                                    </tr>
                                    {errorData.results.map(item =>
                                        (!item.success && <tr>
                                            <td className='text_left'>{item.error}</td>
                                        </tr>)
                                    )}
                                </table>
                            </div>
                        </div>
                        : ''}
                        {user && user.length && (
                            <div className="custom-pagination">
                                <ReactPaginate
                                    previousLabel={""}
                                    nextLabel={""}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={Math.ceil(user.length/15)}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                    forcePage={currentPage}
                                />
                            </div>
                        )}
                    <div className="field_row text_center pb_25 mb_0">
                        <button className="uppercase active" onClick={closeModal}>OK</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PafFpgConvertModal